import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { GlobalService } from 'src/app/services/global.service';
import { HttpService } from 'src/app/services/http.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DatepickerOptions } from 'ng2-datepicker';
import * as enLocale from 'date-fns/locale/en';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { configs } from 'src/app/configs/app.config';


@Component({
  // changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-editwidget',
  templateUrl: './editwidget.component.html',
  styleUrls: ['./editwidget.component.scss']
})

export class EditwidgetComponent implements OnInit {
  public options: DatepickerOptions = {
    locale: enLocale,
    placeholder: 'Select Date',
    displayFormat: 'DD/MM/YY',
  };

  @Input() listData: any;
  @Input() index: any;
  @Input() content: any;
  @Input() update: any;
  @Input() cardName: any;
  @Input() editGraph: any;
  @Input() subCompare: any;
  @Output() valueChange = new EventEmitter();

  public networktag: any;
  public location: any;
  public networks: any;
  public editGraphs: FormGroup;
  public errorMessage: string = '';
  public successMessage: string = '';
  public warningMessage: string = '';
  public startDate: any;
  public endDate: any;
  public isSubmitted: boolean = false;
  public timeWindow: any;
  public deviceCategory: any;
  public scoreName: any;
  // public stream: boolean;
  public date: Date = new Date();
  public _listData: any;
  public dropdownSettings: IDropdownSettings = {};
  public xValueList: Array<any> = [];
  public aggregationList: Array<any> = [];
  public kpiList: Array<any> = [];
 
  public model: any = {
    // beginDate: { year: 20, month: 04, day: 01 },
    // endDate: { year: '', month: '', day: '' }
  };

  constructor(private ngxService: NgxUiLoaderService, public cd: ChangeDetectorRef, public globalService: GlobalService, private formBuilder: FormBuilder, public httpService: HttpService, ) {
    if (this.globalService && this.globalService.order_id) {
      this.fetchxValueList();
      this.fetchaggregationList();

    }
    else {
      let inter = setInterval(() => {
        if (this.globalService && this.globalService.order_id) {
          clearInterval(inter);
          this.fetchxValueList();
          this.fetchaggregationList();
        }
      }, 100);
    }

    this.editGraphs = this.formBuilder.group({
      networktag: [''],
      networktag_select_name: [''],
      location: [''],
      location_select_name: [''],
      scoreName: [''],
      scoreName_select_name: [''],
      xValue: [''],
      xValue_select_name: [''],
      networks: [''],
      networks_select_name: [''],
      aggregation: [''],
      aggregation_select_name: [''],
      kpiType:[''],
      kpiType_select_name:[''],
      timeWindow: [''],
      timeWindow_select_name: [''],
      locationArray: [],
      deviceCategoryArray: [],
      appVersionArray: [],
      telcoArray: [],
      appNameArray: [''],
      networkTagArray: [],
      timeWindowArray: [''],
      platformArray: [''],
      peersArray: [''],
      model: [''],
      // videoStreamType: [''],
      widgetName: [''],
      startDate: [''],
      endDate: [''],
    });
  }

  private fetchxValueList(): void {
    this.httpService.createGetRequest(configs['api']['fetchXvalue'] + this.globalService.order_id + '?type=' + this.globalService.orderType).subscribe((response: any) => {
      if (response)
        this.xValueList = this.globalService.toObject('', response);
    })
  }
  private fetchaggregationList(): void {
    this.httpService.createGetRequest(configs['api']['fetchAggregation'] + this.globalService.order_id).subscribe((response: any) => {
      if (response)
        this.aggregationList = this.globalService.toObject('', response);
    });
  }
  getMonthValue(value): string {
    let m = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN",
      "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    for (let index = 0; index < m.length; index++) {
      const element = m[index];
      if (element == value)
        return index < 10 ? '0' + index : '' + index;
    }
  }

  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 2,
      allowSearchFilter: false
    };
  }

  changeDateFormat(object) {
    return (('' + object['day']).length == 1 ? '0' + object['day'] : object['day']) + '-' + (('' + object['month']).length == 1 ? this.globalService.monthchange(+('0' + object['month'])) : this.globalService.monthchange(+object['month'])) + '-' + object['year'];
  }

  forPopupClose() {
    this.globalService.showPopUp = "";
    document.body ? document.body.classList.remove('no-scroll') : '';
  }

  fillData(type: string, inputArr: Array<any>) {
    if (this._listData[type] && this._listData[type].length > 0) {
      let arr = [];
      for (let index = 0; index < inputArr.length; index++) {
        const element = inputArr[index];
        if (this._listData[type].indexOf(element['item_text']) > -1) {
          let obj = { 'item_id': element['item_id'], "item_text": element['item_text'] };
          arr.push(obj);
        }
      }
      let obj = {};
      obj[type + 'Array'] = arr;
      this.editGraphs.patchValue(obj);
    }
  }
  public storeKpiValue:any = '';
  ngDoCheck() {
    if (this.listData && this.listData != this._listData) {
      this._listData = this.listData;
      if (this._listData && this._listData['scoreName']) {

        this.fillData('location', this.globalService.dropdownList);
        this.fillData('telco', this.globalService.multiSelectNetwork);
        this.fillData('networkTag', this.globalService.multiSelectSpeed);
        this.fillData('appVersion', this.globalService.multiSelectAppVersion);
        this.fillData('platform', this.globalService.multiSelectPlatform);
        this.fillData('timeWindow', this.globalService.multiSelectTimeWindow);
        this.fillData('deviceCategory', this.globalService.multiSelectDeviceCategory);
        if(this.globalService.orderType=='app'){
        this.fillData('peers',this.globalService.multiselectAppsList);
        this.fillData('telco', this.globalService.multiSelectNetwork);
        }
        if(this.globalService.orderType=='telco'){
        this.fillData('peers',this.globalService.multiSelectNetwork);
        this.fillData('appName', this.globalService.multiselectAppsList);
        }
        this.storeKpiValue = this._listData.scoreName;
        this.editGraphs.patchValue({
          scoreName: this._listData && this._listData.scoreName && this._listData.scoreName ? this._listData.scoreName : '',
          scoreName_select_name: this._listData && this._listData.scoreName && this._listData.scoreName ? this._listData.scoreName : '',
          networks_select_name: this._listData && this._listData.telco && this._listData.telco[0] ? this._listData.telco[0] : '',
          xValue: this._listData && this._listData.xValue ? this._listData.xValue : '',
          xValue_select_name: this._listData && this._listData.xValue ? this._listData.xValue : '',
          aggregation: this._listData && this._listData.aggregation ? this._listData.aggregation : '',
          kpiType:this._listData && this._listData.raw ? (this._listData.raw?'Metrics':'Index') : 'Index',
          kpiType_select_name:this._listData && this._listData.raw ? (this._listData.raw?'Metrics':'Index') :'Index',
          aggregation_select_name: this._listData && this._listData.aggregation ? this._listData.aggregation : '',
          widgetName: this._listData && this._listData.widgetName ? this._listData.widgetName : '',
          startDate: this._listData && this._listData.startDate ? this._listData.startDate.replace(/-/g, "/") : '',
          endDate: this._listData && this._listData.endDate ? this._listData.endDate.replace(/-/g, "/") : '',
          // videoStreamType: this._listData && this._listData.videoStreamType ? this._listData.videoStreamType : false,
        });
      }
    }
  }

  changeSelection(event) {
    setTimeout(() => {
      let option = event['fieldName'];
      if (option == "scoreName") {
        if (this.update == "updatetimeseries") {
          this.editGraphs.get('widgetName').setValue(event['name'] + '-' + 'Trend');
          // this.editGraphs['controls']['widgetName']['value'] = event['name'] + '-' + 'Trend';
        } else if (this.update == 'updatecompare') {
          this.editGraphs.get('widgetName').setValue(event['name'] + '-' + 'x-axis');
          // this.editGraphs['controls']['widgetName']['value'] = event['name'] + '-' + 'x-axis';
        } else {
          this.editGraphs.get('widgetName').setValue(event['name'] + '-' + 'Distribution');
          // this.editGraphs['controls']['widgetName']['value'] = event['name'] + '-' + 'Distribution';
        }

      }
      // this.cd.detectChanges();
      // setTimeout(() => {
      //   this.cd.detectChanges();
      // }, 0);
    }, 100);

    setTimeout(() => {
      let option = event['fieldName'];
      this.editGraphs.controls[option].setValue(event['id']);
      if(event['fieldName']=='kpiType'){
        if(this._listData.raw==event['id']){
        this.fetchKpiList(this.editGraphs['controls']['kpiType']['value'],true);
        }else{
        this.fetchKpiList(this.editGraphs['controls']['kpiType']['value'],false);
        }
        this.editGraphs.controls[option].setValue(event['id']);
      }
    }, 0);
  }
  public fetchKpiList(val,bool): void {
    this.kpiList = [];
    this.httpService.createGetRequest(configs['api']['fetchKpiList'] + this.globalService.order_id+'?raw='+val).subscribe((response: any) => {
      if (response) 
        this.kpiList = this.globalService.toObject('', response);
        if(bool){
        this._listData.scoreName = this.storeKpiValue;
        this.editGraphs.get('scoreName').setValue(this._listData.scoreName)
        }else{
        this._listData.scoreName=this.kpiList[0]['id'];
        this.editGraphs.get('scoreName').setValue(this._listData.scoreName)
        }
    });

  }
  cleanBeforeSendParams(obj) {
    //  console.log(obj);
    var arr = [];
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === "--" || obj[propName] === "aN--NaN" ||
        obj[propName] === "NaN--NaN" || obj[propName].length === 0 || obj[propName] === " " || obj[propName] === "select"
        || obj[propName] === "Select" || (obj[propName] && obj[propName][0] === "select")) {
        delete obj[propName];
      }
    }
    return obj;
  }


  onSubmit($event) {

    this.isSubmitted = true;
    if (this.editGraphs.valid) {
      let obj = {
        "type": this.globalService.orderType,
        "scoreName": this.editGraphs['controls']['scoreName']['value'] ? this.editGraphs['controls']['scoreName']['value'] : "",
        "mainApp": this.globalService.selectedOrder['mainApp'],
        "speed": this.editGraphs['controls']['networkTagArray']['value'] ? this.globalService.getDataAsString(this.editGraphs['controls']['networkTagArray']['value']) : [],
        "location": this.editGraphs['controls']['locationArray']['value'] ? this.globalService.getDataAsString(this.editGraphs['controls']['locationArray']['value']) : [],
        "widgetId": this.listData._id,
        "startDate": this.editGraphs['controls']['startDate']['value'] ? this.globalService.convertDate(this.editGraphs['controls']['startDate']['value']) : '',
        "endDate": this.editGraphs['controls']['endDate']['value'] ? this.globalService.convertDate(this.editGraphs['controls']['endDate']['value']) : '',
        "widgetName": this.editGraphs['controls']['widgetName']['value'],
        "timeWindow": this.editGraphs['controls']['timeWindowArray']['value'] ? this.globalService.getDataAsString(this.editGraphs['controls']['timeWindowArray']['value']) : [],
        "aggregation": this.editGraphs['controls']['aggregation']['value'] ? this.editGraphs['controls']['aggregation']['value'] : [],
        "xValue": this.editGraphs['controls']['xValue']['value'] ? this.editGraphs['controls']['xValue']['value'] : "",
        "deviceCategory": this.editGraphs['controls']['deviceCategoryArray']['value'] ? this.globalService.getDataAsString(this.editGraphs['controls']['deviceCategoryArray']['value']) : "",
        // "videoStreamType": this.editGraphs['controls']['videoStreamType']['value'],
        "telco": this.editGraphs['controls']['telcoArray']['value'] ? this.globalService.getDataAsString(this.editGraphs['controls']['telcoArray']['value']) : [],
        "appName": this.editGraphs['controls']['appNameArray']['value'] ? this.globalService.getDataAsString(this.editGraphs['controls']['appNameArray']['value']) : [],
        "pageTab": this.listData.pageTab,
        "platform": this.editGraphs['controls']['platformArray']['value'] ? this.globalService.getDataAsString(this.editGraphs['controls']['platformArray']['value']) : [],
      };
      //graphtype
      let url = configs['api']['MonitorGraph'] + this.update + '/';
      if (this.cardName == 'benchmarking') {
        url = configs['api']['GraphBenchmark'] + this.update + '/';
        obj["peers"] =   this.editGraphs['controls']['peersArray']['value'] ? this.globalService.getDataAsString(this.editGraphs['controls']['peersArray']['value']) : [];
        if (this.update == 'updatecompare') {
          obj['graphType'] = this.subCompare ? this.subCompare : undefined;
        }
      }
      if(this.update !='updatehistogram'){
      obj['raw']=this.editGraphs['controls']['kpiType']?((this.editGraphs['controls']['kpiType']['value']=='Index'|| this.editGraphs['controls']['kpiType']['value']==false)?false:true):false;
      }
     
      this.httpService.createPutRequest(url, this.cleanBeforeSendParams(obj), this.globalService.order_id).subscribe((response: any) => {
        this.successMessage = 'success';
        this.cd.detectChanges();
        this.globalService.scrollToTop();
        // this.valueChange.emit({ bool: false, ind: this.listData.pageTab });
        this.globalService.updateGraphSourceMethod({ bool: false,type: this.cardName, data: response,ind: this.listData.pageTab });

        setTimeout(() => {
          document.body ? document.body.classList.remove('no-scroll') : '';
          setTimeout(() => {
            this.globalService.showPopUp = "";
          }, 3000);
        }, 0);

      }, (error) => {
        this.globalService.scrollToTop();
        this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';
        this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
        this.cd.detectChanges();
        setTimeout(() => {
          this.errorMessage = "";
          this.warningMessage = "";
        }, 3000);
      });
    }
  }

  deleteGraph(str, id) {
    let ele: any = document.getElementById('forScroll');
    // let url = `UxDashBoard/monitorgraph/`;
    // if (this.cardName == 'benchmarking') {
    //   url = `UxDashBoard/benchmark/`;
    // }
    let url = configs['api']['MonitorGraph'];
    if (this.cardName == 'benchmarking') {
      url = configs['api']['GraphBenchmark'];
    }
    //this.ngxService.start();
    this.httpService.createDeleteRequest(url, str, id, this.globalService.order_id)
      .subscribe((res) => {
        this.ngxService.stop();
        // this.valueChange.emit({ bool: true, ind: this.listData.pageTab });
        this.globalService.updateGraphSourceMethod({ bool: true,type: this.cardName, data: res,ind: this.listData.pageTab });
        this.globalService.scrollToTop();
        this.successMessage = 'success';
        document.body ? document.body.classList.remove('no-scroll') : '';
        setTimeout(() => {
          this.forPopupClose();
        }, 1000)
      },
        (error) => {
          this.globalService.scrollToTop();
          this.errorMessage = error && error['statusMessage'] ? error['statusMessage'] : error && error['error'] && error.error['statusMessage'] ? error.error['statusMessage'] : '';

          this.warningMessage = (error.error['statusCode'] && error.error['statusCode'] === 406) ? error.error['statusMessage'] : '';
          setTimeout(() => {
            this.errorMessage = "";
            this.warningMessage = "";
          }, 4000);

        })
  }
}
